<script setup lang="ts">
import FeedbackContainer from "~/components/Feedback/FeedbackContainer.vue";
</script>

<template>
  <slot />
  <!--
    Every other layout mounts this; without it `useFeedback()` writes into a store nothing renders,
    so a page on this layout shows NO toast at all — neither "Signature enregistrée" nor
    "Impossible d'enregistrer la signature". That is what `/digital-sign-and-sheet` (the link an
    outside trainer receives) was doing: signing worked, and the trainer had no way to know.
    `FeedbackContainer` needs no auth and sits at z-index 501, above GlobalModal's 500.
  -->
  <FeedbackContainer />
</template>

<style lang="scss"></style>
